// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"151":"3eaa2582f7aec4d8","1882":"73e3c42bab19c947","3203":"59d4c3aa7c5dad35","4349":"8fbf9118a9db37c0","5133":"1de6a2d6103ed5df","7060":"70e0ebca9ac3cfa8"}[chunkId] + ".css";
};